const EPSILON = 0.000001;
const PI=Math.PI;
const RADIAN_FACTOR=PI/180;
const DEGREE_FACTOR=180/PI;
let ANGLE_ORDER = "zyx";
let ArrayType = Float64Array;//Float64Array,Float32Array,Array
function setArrayType(v){
    ArrayType=v;
}
function setOrder(order){
  ANGLE_ORDER=order;
}
function clamp( value, min, max ) {

	return Math.max( min, Math.min( max, value ) );

}
export {EPSILON,ANGLE_ORDER,ArrayType,setArrayType,PI,RADIAN_FACTOR,DEGREE_FACTOR,clamp}